module.exports = __webpack_public_path__ + "img/selected0-min.d3907424.png";